export default {
  'subscriptionOrderList.title': '订阅订单列表',
};

/*
export default {
  'subscriptionOrderList.title': '订阅订单列表',
  'orderList.title': '订单管理',
  'orderList.form.reporting': '是否上报',
  'orderList.form.reporting.placeholder': '请选择是否上报',
  'orderList.form.orderNumber': '订单号',
  'orderList.form.orderNumber.placeholder': '订单号',
  'orderList.form.merchant': '商户',
  'orderList.form.merchant.placeholder': '商户',
  'orderList.form.shopifyId': 'Shopify ID',
  'orderList.form.shopifyId.placeholder': 'Shopify ID',
  'orderList.form.customerEmail': '客户邮箱',
  'orderList.form.customerEmail.placeholder': '客户邮箱',
  'orderList.form.search': '查询',
  'orderList.form.reset': '重置',
  'orderList.form.advancedSearch': '高级搜索',
  'orderList.form.orderStatus': '订单状态',
  'orderList.form.orderStatus.placeholder': '订单状态',
  'orderList.form.paymentStatus': '支付状态',
  'orderList.form.paymentStatus.placeholder': '支付状态',
  'orderList.form.paymentMethod': '支付方式',
  'orderList.form.paymentMethod.placeholder': '请选择支付方式',
  'orderList.form.isSubscription': '是否订阅',
  'orderList.form.isSubscription.placeholder': '是否订阅',
  'orderList.form.pageSource': '页面来源',
  'orderList.form.pageSource.placeholder': '请选择页面来源',
  'orderList.form.dateRange': '时间范围',
  'orderList.form.startTime': '开始时间',
  'orderList.form.endTime': '结束时间',
  'orderList.status.created': '创建',
  'orderList.status.createdOrPendingSync': '创建/待同步',
  'orderList.status.pending': '待处理',
  'orderList.status.approved': '已批准',
  'orderList.status.fulfilled': '已完成',
  'orderList.status.completed': '已完成',
  'orderList.status.cancelled': '已取消',
  'orderList.status.failed': '失败',
  'orderList.status.abnormal': '异常',
  'orderList.status.pendingSync': '待同步',
  'orderList.paymentStatus.createOrder': '未支付',
  'orderList.paymentStatus.paid': '已支付',
  'orderList.paymentStatus.pending': '待付款',
  'orderList.paymentStatus.pendingPay': '支付处理中',
  'orderList.paymentStatus.failed': '支付失败',
  'orderList.operation.export': '导出',
  'orderList.operation.exportSelected': '导出选中数据',
  'orderList.operation.statistics': '订单统计',
  'orderList.export.noSelection': '请先选择要导出的数据',
  'orderList.export.exportSuccess': '导出成功',
  'orderList.actions.refresh': '刷新',
  'orderList.actions.density': '密度',
  'orderList.actions.columnSetting': '列设置',
  'orderList.columns.index': '#',
  'orderList.columns.orderNumber': '订单号',
  'orderList.columns.shopName': '店铺名称',
  'orderList.columns.merchant': '商户',
  'orderList.columns.shopifyId': 'Shopify ID',
  'orderList.columns.email': '客户邮箱',
  'orderList.columns.productName': '产品名称',
  'orderList.columns.quantity': '数量',
  'orderList.columns.subtotal': '小计',
  'orderList.columns.shipping': '运费',
  'orderList.columns.tax': '税费',
  'orderList.columns.total': '总金额',
  'orderList.columns.currency': '货币',
  'orderList.columns.paymentMethod': '支付方式',
  'orderList.columns.paymentStatus': '支付状态',
  'orderList.columns.orderStatus': '订单状态',
  'orderList.columns.reporting': '是否上报',
  'orderList.columns.isSubscription': '是否订阅',
  'orderList.columns.createdAt': '创建时间',
  'orderList.isSubscription.yes': '是',
  'orderList.isSubscription.no': '否',
  'orderList.reporting.yes': '是',
  'orderList.reporting.no': '否',
  'orderList.columns.operations': '操作',
  'orderList.columns.operations.view': '查看',
  'orderList.columns.operations.forceComplete': '同步',
  'orderList.columns.operations.forceCompleteSuccess': '订单同步成功',
  'orderList.columns.operations.forceCompleteError': '订单同步失败',
  'orderList.size.mini': '迷你',
  'orderList.size.small': '小',
  'orderList.size.medium': '中',
  'orderList.size.large': '大',
  'orderList.detail.title': '订单详情',
  'orderList.detail.orderStatus': '订单状态',
  'orderList.detail.paymentStatus': '支付状态',
  'orderList.detail.orderInfo': '订单信息',
  'orderList.detail.orderNumber': '订单号',
  'orderList.detail.paymentMethod': '支付方式',
  'orderList.detail.shopifyId': 'Shopify ID',
  'orderList.detail.currency': '货币',
  'orderList.detail.customerInfo': '客户信息',
  'orderList.detail.customerName': '客户姓名',
  'orderList.detail.customerEmail': '客户邮箱',
  'orderList.detail.productInfo': '商品信息',
  'orderList.detail.sku': 'SKU',
  'orderList.detail.quantity': '数量',
  'orderList.detail.unitPrice': '单价',
  'orderList.detail.subtotal': '小计',
  'orderList.detail.amountInfo': '金额信息',
  'orderList.detail.shipping': '运费',
  'orderList.detail.tax': '税费',
  'orderList.detail.handling': '手续费',
  'orderList.detail.tip': '小费',
  'orderList.detail.originTotal': '原始总价',
  'orderList.detail.total': '总金额',
  'orderList.detail.addressInfo': '地址信息',
  'orderList.detail.shippingAddress': '收货地址',
  'orderList.detail.billingAddress': '账单地址',
  'orderList.detail.timeInfo': '时间信息',
  'orderList.detail.createdAt': '创建时间',
  'orderList.detail.updatedAt': '更新时间',
  'orderList.productDetail.title': '商品详情',
  'orderList.productDetail.unitPrice': '单价',
  'orderList.productDetail.quantity': '数量',
  'orderList.productDetail.subtotal': '小计',
  'orderList.productDetail.detailInfo': '详细信息',
  'orderList.productDetail.weight': '重量',
  'orderList.productDetail.variantId': '变体ID',
  'orderList.detail.adParams': '广告参数',
  'orderList.detail.loadError': '获取订单详情失败',
  'orderList.detail.phone': '电话',
  'orderList.detail.discountCode': '折扣码',
  'orderList.detail.cartToken': '购物车Token',
  'orderList.detail.pageSource': '页面来源',
  'orderList.detail.paymentProcess': '支付处理过程',
  'orderList.detail.paymentGateway': '支付网关',
  'orderList.detail.paymentAmount': '支付金额',
  'orderList.detail.clientIp': '客户端IP',
  'orderList.detail.paymentMessage': '支付消息',
  'orderList.detail.paymentError': '支付错误',
  'orderList.detail.paymentConfig': '支付配置',
  'orderList.detail.gatewayType': '网关类型',
  'orderList.detail.gatewayAlias': '网关别名',
  'orderList.detail.paymentResult': '支付结果',
  'orderList.detail.transactionToken': '交易Token',
  'orderList.detail.transactionState': '交易状态',
  'orderList.detail.transactionMessage': '交易消息',
  'orderList.detail.transactionSucceeded': '交易成功',
  'orderList.detail.failureReason': '失败原因',
  'orderList.detail.lastErrorAt': '最后错误时间',
  'orderList.detail.paymentInfo': '支付信息',
  'orderList.detail.spreedlyOrderStatus': 'Spreedly订单状态',
  'orderList.detail.paypalOrderStatus': 'PayPal订单状态',
  'orderList.detail.paypalOrderId': 'PayPal订单ID',
  'orderList.detail.capturePaypal': '立即捕获',
  'orderList.detail.capturePaypalSuccess': 'PayPal订单捕获成功',
  'orderList.detail.capturePaypalError': 'PayPal订单捕获失败',
  'orderList.detail.checkoutInfo': '结账信息',
  'orderList.detail.funnelId': '漏斗ID',
  'orderList.detail.zoneId': '区域ID',
  'orderList.detail.checkoutIp': '结账IP',
  'orderList.detail.checkoutLanguage': '结账语言',
  'orderList.detail.sourceUrl': '来源URL',
  'orderList.detail.shopifyTags': 'Shopify标签',
  'orderList.detail.customAttributes': '自定义属性',
  'orderList.detail.attributeKey': '属性键',
  'orderList.detail.attributeValue': '属性值',
  'orderList.detail.processTime': '处理时间',
  'orderList.detail.shopifyDraftOrderId': 'Shopify草稿订单ID',
  'orderList.detail.pixelReporting': 'Pixel 上报状态',
  'orderList.detail.tiktokReporting': 'TikTok 上报',
  'orderList.detail.facebookReporting': 'Facebook 上报',
  'orderList.detail.facebookError': 'Facebook 错误',
  'orderList.detail.newsbreakReporting': 'Newsbreak 上报',
  'orderList.detail.newsbreakError': 'Newsbreak 错误',
  'orderList.detail.success': '成功',
  'orderList.detail.failed': '失败',
};
*/
